export default {
  SET_DEPARTURE: (state, payload) => (state.departure = payload),
  SET_TRAININGS: (state, payload) => (state.trainings = payload),
  SET_ONBOARDING: (state, payload) => (state.onboarding = payload),
  SET_ORIENTATION: (state, payload) => (state.orientation = payload),
  SET_SEQUENCE: (state, payload) => (state.sequence = payload),
  SET_COMPLETED_SEQUENCE: (state, payload) => (state.completedSequence = payload),
  SET_COMPLETED_ASSOCIATE_SEQUENCE: (state, { type, payload }) => (state.completedAssociateSequence[type] = payload),
  SET_PACKAGES: (state, payload) => (state.packages = payload),
  SET_PURCHASED: (state, payload) => (state.purchased = payload)
}
